import script from "./homegameActivity.vue?vue&type=script&setup=true&lang=js"
export * from "./homegameActivity.vue?vue&type=script&setup=true&lang=js"

import "./homegameActivity.vue?vue&type=style&index=0&id=bf7da320&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf7da320"]])

export default __exports__